import React, { useRef, useEffect } from 'react';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import {
	TitleComponent,
	TooltipComponent,
	LegendComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	PieChart,
	CanvasRenderer,
]);

const EChartsDoughnutChart = ({ options, style }) => {
	const chartRef = useRef(null);

	useEffect(() => {
		let chartInstance = null;
		if (chartRef.current) {
			chartInstance = echarts.init(chartRef.current);
			chartInstance.setOption({
				textStyle: { fontSize: 11 },
				...options,
				tooltip: { textStyle: { fontSize: 11 }, ...(options?.tooltip || {}) },
			});
		}

		const resizeChart = () => {
			chartInstance?.resize();
		};

		window.addEventListener('resize', resizeChart);

		return () => {
			chartInstance?.dispose();
			window.removeEventListener('resize', resizeChart);
		};
	}, [options]);

	return (
		<div
			ref={chartRef}
			style={{ width: '100%', height: '300px', ...style }}
		/>
	);
};

export default EChartsDoughnutChart;
